import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { Review } from './models/review.model';
import { ReviewRequest } from './models/review-request.model';
import {
  getEligibleClients,
  getError,
  getRequestReviewSending,
  getReviewDetail,
  getReviewRequest,
  getReviews,
  getReviewSettings,
  getReviewSummary,
} from './review-data.reducer';
import { filter, take } from 'rxjs/operators';
import { ReviewClient } from './models/review-client.model';
import { ReviewSummary } from './models/review-summary.model';
import { IReviewSettings } from './review-data.data';

@Injectable()
export class ReviewDataStore {
  reviews$: Observable<List<Review>> = this._store.select(getReviews);
  eligibleClients$: Observable<List<ReviewClient>> = this._store.select(
    getEligibleClients
  );
  reviewRequest$: Observable<ReviewRequest> = this._store.select(
    getReviewRequest
  );
  requestReviewSending$: Observable<boolean> = this._store.select(
    getRequestReviewSending
  );
  reviewSummary$: Observable<ReviewSummary> = this._store.select(
    getReviewSummary
  );
  reviewDetail$: Observable<Review> = this._store.select(getReviewDetail);
  reviewSettings$: Observable<IReviewSettings> = this._store.select(
    getReviewSettings
  );
  error$: Observable<Error> = this._store.select(getError);

  constructor(private _store: Store<any>) {}

  getReviews(): Observable<List<Review>> {
    return this.reviews$.pipe(filter<List<Review>>(Boolean), take(1));
  }

  getReviewRequest(): Observable<ReviewRequest> {
    return this.reviewRequest$.pipe(filter<ReviewRequest>(Boolean), take(1));
  }

  getReviewSummary(): Observable<ReviewSummary> {
    return this.reviewSummary$.pipe(filter<ReviewSummary>(Boolean), take(1));
  }

  getReviewDetail(): Observable<Review> {
    return this.reviewDetail$.pipe(filter<Review>(Boolean), take(1));
  }

  getReviewSettings(): Observable<IReviewSettings> {
    return this.reviewSettings$.pipe(
      filter((x) => !!x),
      take(1)
    );
  }
}
